import React, { Component } from 'react'

class AddTeacher extends Component {
    state = {
        formclass: ""
    }
    addTeacherToJSON = (event) => {
        console.log("clicked")
        event.preventDefault();
        console.log("submitted")
        this.setState({ formclass: "was-validated" })

        // alert("You are submitting " + this.state.username);

    }
    render() {
        return (
            <div style={{ padding: "10px" }}>

                <form className={this.state.formclass} onSubmit={this.addTeacherToJSON}>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="card">
                                <div className="card-header bg-primary" style={{ color: "white" }}>Teacher Details</div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label ><b>First Name</b></label>
                                            <input type="text" className="form-control" id="teacherFname" placeholder="Enter First Name"
                                                name="fname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Last Name</b></label>
                                            <input type="text" className="form-control" id="lname" placeholder="Enter Last Name"
                                                name="teacherLname" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-6">
                                            <label><b>Date of Birth</b></label>
                                            <input type="date" className="form-control" id="dobOfteacher" placeholder="" name="fname"
                                                required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div className="form-group col-lg-6">
                                            <label ><b>Gender</b></label><br />
                                                    Male <input type="radio" id="teacherGender" name="teacherGender" value="Male" required />
                                                    Female <input type="radio" id="teacherGender" name="teacherGender" value="Female" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label ><b>Email Id</b></label>
                                            <input type="email" className="form-control" id="teacherEmail" placeholder="xyz@gmail.com"
                                                name="teacherEmail" required />
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="form-group col-lg-12">
                                            <label><b>Current Address</b></label>
                                            <input type="text" className="form-control" id="teacherCurrrentAddress" placeholder="Current Address"
                                                name="teacherCurrrentAddress" required />
                                            <br />
                                            <div className="row">
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="teacherCurrentCity" placeholder="City"
                                                        name="teacherCurrentCity" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="teacherCurrentCountry" placeholder="Country"
                                                        name="teacherCurrentCountry" required />
                                                </div>
                                                <div className="col-lg-4">
                                                    <input type="text" className="form-control" id="teacherCurrentPincode" placeholder="Pincode"
                                                        name="teacherCurrentPincode" required />
                                                </div>
                                            </div>
                                            <div className="valid-feedback">Valid.</div>
                                            <div className="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-lg-12">
                                            <label ><b>Blood Group(Optional)</b></label>
                                            <input type="text" class="form-control" id="teacherBlood" placeholder="xyz@gmail.com"
                                                name="teacherBlood" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-lg-12">
                                            <label ><b>Username</b></label>
                                            <input type="text" class="form-control" id="teacherUsername" placeholder="Enter Username"
                                                name="teacherUsername" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-lg-6">
                                            <label ><b>Password</b></label>
                                            <input type="password" class="form-control" id="teacherPwd" placeholder="********"
                                                name="teacherPwd" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div class="form-group col-lg-6">
                                            <label><b>Password</b></label>
                                            <input type="password" class="form-control" id="teacherCnfPwd" placeholder="********"
                                                name="teacherCnfPwd" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-lg-12">
                                            <label><b>Qualification</b></label>
                                            <input type="text" class="form-control" id="teacherQualification" placeholder="Highest Education Degree"
                                                name="teacherQualification" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <label ><b>Profile Image</b></label><br />
                                            <label for="teacherProfilePhoto" class="file-upload btn btn-primary"><i class="fa fa-upload mr-2"></i>Browse for file ...
                                                <input id="teacherProfilePhoto" type="file" />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-6">
                            <div class="card">
                                <div class="card-header bg-primary" style={{ color: "white" }}>
                                    School Info
                                         </div>
                                <div class="card-body">
                                    <div class="row">
                                        <div class="form-group col-lg-12">
                                            <label ><b>Date of joining</b></label>
                                            <input type="date" class="form-control" id="dateOfjoining" placeholder="" name="dateOfjoining"
                                                required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="form-group col-lg-6">
                                            <label ><b>Class</b></label>
                                            <input type="text" class="form-control" id="teacherClassName" placeholder="Enter Class Name"
                                                name="teacherClassName" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                        <div class="form-group col-lg-6">
                                            <label ><b>Roll No</b></label>
                                            <input type="text" class="form-control" id="pwd" placeholder="Enter Roll No"
                                                name="lname" required />
                                            <div class="valid-feedback">Valid.</div>
                                            <div class="invalid-feedback">Please fill out this field.</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />

                            <div class="row">
                                <div class="col-lg-12 " style={{ textAlign: "end" }}>
                                    <button type="submit" class="btn btn-primary">Submit</button>
                                    <button type="reset" class="btn btn-success">Reset</button>
                                    <button class="btn btn-primary">Back</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>

            </div>
        );
    }
}

export default AddTeacher;